import React, { useState, useCallback } from 'react'
import { List, Typography, CircularProgress } from '@material-ui/core'
import { Mascotte } from 'sputnik-ui'
import DeviceSearchSuggestion from 'components/atoms/DeviceSearchSuggestion'
import { useTranslation } from 'react-i18next'
import { EditThirdPartyCameras } from 'features/EditThirdPartyCameras'
import { EditThirdPartyIntercom } from 'features/Devices/EditThirdPartyIntercom'
import { DeviceServiceNoteModal } from 'features/DeviceServiceNote'
import { trackHomeListOpen } from 'utils/navMetrics'

// getRowProps(device, index) — необязательные пропсы строки (details, to,
// disabled, secondaryAction, onOpen) для новой главной (business_apps#1486);
// emptyHint — подсказка под «Ничего не найдено». Без них список как раньше.
const DevicesList = ({
  loading,
  devices,
  firstInstalled,
  navContext,
  getRowProps,
  emptyHint,
}) => {
  const { t } = useTranslation(['messages', 'devices', 'common'])

  // Клик по строке списка на главной (business_apps#1465).
  const handleOpen = useCallback(
    (device, index) => trackHomeListOpen({ device, index, ...navContext }),
    [navContext]
  )
  const [thirdPartyCameraModal, setThirdPartyCameraModal] = useState(false)
  const [thirdPartyIntercomModal, setThirdPartyIntercomModal] = useState(false)

  const handleCloseCameraModal = useCallback(() => {
    setThirdPartyCameraModal(false)
  }, [])

  const handleOpenCameraModal = useCallback(({ uuid }) => {
    setThirdPartyCameraModal(uuid)
  }, [])

  const handleCloseIntercomModal = useCallback(() => {
    setThirdPartyIntercomModal(false)
  }, [])

  const handleOpenIntercomModal = useCallback(({ uuid }) => {
    setThirdPartyIntercomModal(uuid)
  }, [])

  const [serviceNoteDevice, setServiceNoteDevice] = useState(null)

  const handleOpenServiceNoteModal = useCallback((device) => {
    setServiceNoteDevice(device)
  }, [])

  const handleCloseServiceNoteModal = useCallback(() => {
    setServiceNoteDevice(null)
  }, [])

  return devices ? (
    devices.length > 0 ? (
      <>
        <List>
          {devices.map((device, idx) => (
            <DeviceSearchSuggestion
              handleOpenModal={handleOpenCameraModal}
              handleOpenIntercomModal={handleOpenIntercomModal}
              handleOpenServiceNoteModal={handleOpenServiceNoteModal}
              firstInstalled={firstInstalled}
              onOpen={() => handleOpen(device, idx)}
              key={device.uuid}
              {...device}
              {...(getRowProps ? getRowProps(device, idx) : {})}
            />
          ))}
        </List>
        <EditThirdPartyCameras
          open={!!thirdPartyCameraModal}
          uuid={thirdPartyCameraModal}
          onClose={handleCloseCameraModal}
        />
        <EditThirdPartyIntercom
          open={!!thirdPartyIntercomModal}
          uuid={thirdPartyIntercomModal}
          onClose={handleCloseIntercomModal}
        />
        <DeviceServiceNoteModal
          open={!!serviceNoteDevice}
          device={serviceNoteDevice}
          onClose={handleCloseServiceNoteModal}
        />
      </>
    ) : (
      !loading && (
        <>
          <Mascotte
            emote="404"
            style={{ maxHeight: 400, margin: '2rem auto' }}
          />
          <Typography align="center" variant="h6" color="textSecondary">
            {t('messages:content.empty')}
          </Typography>
          {emptyHint && (
            <Typography align="center" color="textSecondary">
              {emptyHint}
            </Typography>
          )}
        </>
      )
    )
  ) : (
    <div style={{ height: '8rem' }}>
      <CircularProgress />
    </div>
  )
}

export default DevicesList
